module.exports = __webpack_public_path__ + "img/articles2.6f7caac7.svg";